export default abstract class CustomError extends Error {
    abstract statusCode : number;
    abstract publicCode : string;
    abstract name : string;
}